import type { IconName } from "@fortawesome/fontawesome-common-types";

export function getIconNameHandler(iconName: string): IconName {
  return iconName
    .replace(/fa fa-/g, "")
    .replace(/-o/g, "")
    .replace(/-alt/g, "") as IconName;
}
